<template>
    <div>
        <div class="main-cnt ex-has-btm" style="padding: 20px 10px 0px 10px">
            <div class="block-cnt">
                <div class="content-wallet">
                    <ul class="nav nav-tabs" v-show="isSubContract()">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{ 'active': screenType == constants.SubContractScreenType }"
                                @click="switchScreen(constants.SubContractScreenType)"
                            >
                                <i class="icon-sub-contract-red mr-2"></i>
                                {{$t('tab.sub_contract')}}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active': screenType == constants.ChangeContractScreenType}"
                                @click="switchScreen(constants.ChangeContractScreenType)">
                                <i class="icon-change-sub-contract-red mr-2"></i>
                                {{$t('tab.change_contract')}}
                            </a>
                        </li>
                    </ul>
                    <div class="other-nav" v-show="screenType == constants.OtherContractScreenType"
                        @click="switchScreen(constants.OtherContractScreenType)">
                        <div class="active-tab">
                            <div class="tab-item">
                                <i class="icon-other-contract-red mr-2"></i>
                                {{$t('tab.other_contract')}}
                            </div>
                        </div>
                    </div>
                    <ul class="nav nav-tabs" v-show="screenType == constants.PartnerContractScreenType">
                        <li class="nav-item">
                            <div class="nav-link active">
                                <i class="icon-partner-contract-red mr-2"></i>
                                {{$t('tab.partner_contract')}}
                            </div>
                        </li>
                        <li class="nav-item"></li>
                    </ul>
                </div>

                <tour-info></tour-info>

                <div class="mt-4 heading-breadcrumb">
                    <div v-if="screenType == constants.OtherContractScreenType">証憑明細登録 > 契約書 > その他</div>
                    <div v-else-if="screenType == constants.SubContractScreenType">証憑明細登録 > 契約書 > 業務委託契約書</div>
                    <div v-else-if="screenType == constants.ChangeContractScreenType">証憑明細登録 > 契約書 > 変更契約書</div>
                    <div v-else-if="screenType == constants.PartnerContractScreenType">証憑明細登録 > 契約書 > 委託先契約書</div>
                </div>

                <div class="content-wallet">
                    <div class="tab-content">
                        <div class="table-static">
                            <div v-for="(item, index) in contracts" :key="index">
                                <div class="table-heading">{{ item.month }}</div>
                                <div class="table-cnt">
                                    <ul class="lst-static">
                                        <li v-for="row in item.contracts" :key="row.id" :class="{'ex-highlight-row': activeRow == row.id}"
                                            @click="e=> { if (activeRow != row.id) detailContract(row.id); }">
                                            <voucher-row
                                                :voucher="row"
                                                :screenType="screenType">
                                            </voucher-row>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btns-btm">
                    <button class="btn btn-pink-44 w-100 ex-orange-light" @click="addVoucherCamera()">
                        <i class="icon-camera mr-2"></i>
                        {{ $t('voucher.button.add_details') }}
                        <input
                            type="file"
                            ref="inputUpload"
                            name
                            class="d-none"
                            accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                            application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"                            multiple
                            @change="preprocessUpload"
                            style="display: none"
                        />
                    </button>
                </div>
            </div>
        </div>

        <SpCameraPreProcessingVoucher
            v-if="showPreprocessingUpload"
            :files.sync="files"
            :voucherType="voucherType"
            :filePath="filePath"
            @finish="finishUpload"
            @close="closePreprocessingUpload"
            @enableButton="$emit('enableButton', $event)"
            @update:actionHandler="$emit('update:actionHandler', $event)"
            @update:backHandler="$emit('update:backHandler', $event)"
            @update-filePath="changeFilePath"
        ></SpCameraPreProcessingVoucher>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

import StorageService from "@/services/common/storage.service";
import VoucherService from "@/services/module/voucher.service";
import { AuthService } from "@/services/common/auth.service";

import TourInfo from "@/views/components/sp/Tour/Info";
import SpCameraPreProcessingVoucher from "@/views/components/sp/Voucher/CameraPreProcessing";
import VoucherRow from "@/views/components/common/VoucherRow";

export default {
    components: {
        TourInfo,
        SpCameraPreProcessingVoucher,
        VoucherRow
    },
    name: "SpSubContracts",
    data () {
        return {
            constants: Constants,
            utils: Utils,
            groupType: Constants.GroupVoucherType.contract,
            screenType: Constants.SubContractScreenType,
            activeRow: "",
            contracts: [],

            voucher: {},
            voucherType: "",
            voucherParams: {
                voucherTypeId: "",
                cashInOutType: "",
                cashId: "",
            },
            ocrData: {},
            files:[],
            filePath: "",
            signature: false,
            showPreprocessingUpload: false,

            modeAdd: false
        };
    },
    beforeMount () {
        this.switchScreen(!Utils.isEmptyStr(this.$route.query.screenType) ? this.$route.query.screenType : 1);
    },
    methods: {
        listVouchers () {
            this.reset();
            this.setVoucherType();
            return VoucherService.subContracts(this.voucherType).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    const errCode = Utils.getErrorCode(response);
                    if (errCode) {
                        const msg = this.$root.$t("error.error_code_" + errCode);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.contracts = this.formatContract(response.data);
                    } else {
                        this.listVoucher = [];
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            }).catch (err => {
                this.errorMessage = this.$root.$t("error.error_unknown");
            });
        },
        // 証憑詳細表示
        detailContract (id) {
            this.activeVoucher = id;
            this.$router.push({
                path: "/voucher/detail",
                query: { voucherId: id, screenType: "" },
            });
        },
        switchScreen (screenType) {
            this.allReset();
            this.screenType = screenType;
            this.listVouchers(this.screenType);
        },
        formatContract(datas) {
            const result = [];
            let dateGroup = DateUtils.formatDateYYYYMM(new Date(datas[0].transaction_date));
            let contracts = [];
            for (const row of datas) {
                const dateYYYYMM = DateUtils.formatDateYYYYMM(new Date(row.transaction_date));
                if (dateGroup != dateYYYYMM) {
                    const resultRow = {
                        month: dateGroup,
                        contracts: contracts,
                    };
                    result.push(resultRow);
                    dateGroup = dateYYYYMM;
                    contracts = [];
                }
                contracts.push(row);
            }
            const resultRow = {
                month: dateGroup,
                contracts: contracts,
            };
            result.push(resultRow);
            return result;
        },
        setVoucherType () {
            if (this.screenType == Constants.SubContractScreenType) {
                this.voucherType = Constants.VoucherType.contract_outsourcing.id;
            } else if (this.screenType == Constants.ChangeContractScreenType) {
                this.voucherType = Constants.VoucherType.change_contract.id;
            } else if (this.screenType == Constants.OtherContractScreenType) {
                this.voucherType = Constants.VoucherType.contract_other.id;
            } else if (this.screenType == Constants.PartnerContractScreenType) {
                this.voucherType = Constants.VoucherType.partner_contract.id;
            };
        },

        addVoucherCamera () {
            this.reset();
            this.setVoucherType();

            this.selectFiles();
        },

        selectFiles () {
            this.$refs.inputUpload.click();
        },
        preprocessUpload (e) {
            if (e.target.files.length > 10) {
                alert(this.$t('voucher.upload.max_file'));
                // turn on body scroll
                const el = document.body;
                el.classList.remove("over-hidden");
            } else {
                var files = [];
                for (let i = 0; i < e.target.files.length; i++) {
                    files.push(e.target.files[i]);
                }
                this.files = files;

                if (this.files.length != 0 ) {
                    if (this.isPdf(this.files)) {
                        this.getFormData().then(formD => {
                            return VoucherService.checkPwdPdf(formD);
                        }).then(response => {
                            if (response.status == 423) {
                                StorageService.saveExpired();
                                AuthService.doLogout();
                            } else if (response.status != 200) {
                                let errorCode = Utils.getErrorCode(response);
                                let msg = this.$root.$t("fail.add_fail");
                                if (errorCode) {
                                    msg = this.$root.$t("error.error_code_" + errorCode);
                                }
                                this.$toasted.error(msg, {});
                            } else {
                                let msg = this.$root.$t("success.add_success");
                                this.$toasted.success(msg, {});
                                this.showPreprocessingUpload = true;
                            }
                        });
                    } else {
                        let msg = this.$root.$t("success.add_success");
                        this.$toasted.success(msg, {});
                        this.showPreprocessingUpload = true;
                    }
                }

                // turn off body scroll
                const el = document.body;
                el.classList.add("over-hidden");
            }

            // Reset input file
            e.target.value = "";
        },

        isPdf(files) {
            for (let file of files) {
                if (file.type == 'application/pdf') {
                    return true;
                }
            }
            return false;
        },
        async getFormData() {
            let formData = new FormData();
            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                formData.append('files', file);
            }
            return formData;
        },
        changeFilePath (filePath) {
            this.filePath = filePath;
        },
        finishUpload (responseData) {
            const el = document.body;
            el.classList.remove("over-hidden");
            this.ocrData = responseData;
            this.signature = this.ocrData.signature;
            this.goToAddVoucher();
        },
        closePreprocessingUpload () {
            this.$emit("update:backHandler", () => {
                this.$router.go(-1);
            });
            this.$emit("enableButton");
            this.$emit("update:actionHandler", () => {});
            this.showPreprocessingUpload = false;

            // turn on body scroll
            const el = document.body;
            el.classList.remove("over-hidden");
        },

        goToAddVoucher () {
            this.$router.push({
                path: "/voucher/add",
                query: { screenType: "" },
            });
            this.voucherParams = {};
            this.voucherParams.voucherTypeId = this.voucherType;
            this.voucherParams.cashInOutType = this.screenType;
            this.voucherParams.cashId = this.cashId;
            let filePath = "";
            if (this.ocrData.path) {
                filePath = this.ocrData.path;
            }

            this.voucherParams.accountName = this.ocrData.accountName;
            this.voucherParams.totalAmount = this.ocrData.totalAmount;
            this.voucherParams.filePath = filePath;
            this.voucherParams.signature = this.signature;
            this.voucherParams.modeAdd = this.modeAdd;
            if (!Utils.isEmptyObj(this.ocrData.ocr) && !Utils.isEmptyObj(this.ocrData.ocr.mapping)) {
                let data = this.ocrData.ocr.mapping.template_mapping;
                if (data.transaction_date && data.transaction_date[0]) {
                    this.voucherParams.transactionDate = new Date(
                        data.transaction_date[0]
                    );
                }
            }
            StorageService.saveVoucher(JSON.stringify(this.voucherParams));
        },

        reset () {
            this.errorMessage = "";
            this.voucherType = "";
            this.uploadFiles = [];
            this.previewFileUpload = false;
            this.num = 0;
            this.modeAdd = false;
        },
        allReset () {
            this.reset();
            this.contracts = [];
        },
        isSubContract () {
            return this.screenType == Constants.SubContractScreenType || this.screenType == Constants.ChangeContractScreenType;
        },
    },
    watch: {
        $route (to, from) {
            if (!Utils.isEmptyStr(to.query.screenType) && !Utils.isEmptyStr(from.query.screenType) && to.query.screenType != from.query.screenType) {
                this.switchScreen(to.query.screenType);
            }
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/SubContract.vue